import { combineReducers } from 'redux';

import User from './User/';
import Serie from './Serie/';

const Reducer = combineReducers({ User, Serie });

export default Reducer;
